import ProtoBufApi from '@/services/protobuf-api'

export default {
  async getCachedUserInfo() {
    var protoDefinition = require('../../assets/proto/UserInfoModel.proto')
    var message = protoDefinition.User.UserInfoModel
    const result = await ProtoBufApi.get('/access/userinfo')
    const rs = message.decode(new Uint8Array(result.data))
    return rs
  },
  async getLicenceData() {
    // const result = await FqApi.get(`/companies/licencedata`)
    // return result
  }
}
